export const coIntro = {
  label: 'Customer Operations',
  title: 'Customer operations, made easier to run.',
  desc: 'Redesign how requests are received, routed and resolved — with AI handling repeatable work and people staying in control.',
  meta: [
    { k: 'Scope', v: 'Intake → Resolution' },
    { k: 'Systems', v: 'Inbox, helpdesk, CRM' },
    { k: 'Control', v: 'Human review built in' },
  ],
};

export const coFriction = [
  { index: '01', title: 'Manual triage', desc: 'Requests require repetitive sorting and prioritization.' },
  { index: '02', title: 'Fragmented handoffs', desc: 'Information moves between teams and disconnected systems.' },
  { index: '03', title: 'Slow follow-up', desc: 'Manual coordination delays updates and resolution.' },
];

export const coImplement = [
  { index: '01', title: 'Intake & Classification', desc: 'Structure incoming requests and identify what needs attention.' },
  { index: '02', title: 'Routing & System Updates', desc: 'Connect decisions to the tools and teams already in use.' },
  { index: '03', title: 'Human Review & Follow-up', desc: 'Keep approvals, exceptions and consequential decisions under human control.' },
];

export const coRoutingStates = {
  auto: { header: 'LIVE / AUTOMATED', tag: 'AUTOMATED ROUTE', classify: 'Routine identified', action: 'System updated' },
  human: { header: 'LIVE / HUMAN REVIEW', tag: 'REVIEW REQUIRED', classify: 'Exception identified', action: 'Queued for review' },
  rest: { header: 'READY / ROUTING', tag: 'AWAITING REQUEST', classify: 'Classification ready', action: 'Route pending' },
};